export default __webpack_public_path__ + "static/media/76f2cdab0e987076db8b0f48ad63132e.png";